import { Routes } from "@angular/router";
import { loadComponentWithErrorHandling } from "@apps/patient-core/src/app/utils/routing";

const pairRoutes: Routes = [
  {
    path: "pair",
    loadChildren: () => import("./components/pair/pair.routing").then((m) => m.PAIR_ROUTES),
    data: {
      appView: true,
    },
  },
];

const myDentalRoutes: Routes = [
  {
    path: "my-dental",
    loadChildren: () => import("./my-dental/my-dental.routing").then((m) => m.MY_DENTAL_ROUTES),
  },
];

const kioskRoutes: Routes = [
  {
    path: "kiosk-welcome",
    loadComponent: loadComponentWithErrorHandling(() => import("./components/kiosk-welcome/kiosk-welcome.component").then((m) => m.KioskWelcomeComponent)),
  },
  {
    path: "kiosk-late",
    loadComponent: loadComponentWithErrorHandling(() => import("./components/kiosk-late/kiosk-late.component").then((m) => m.KioskLateComponent)),
  },
];

const unsupportedRoute: Routes = [
  {
    path: "unsupported",
    loadComponent: loadComponentWithErrorHandling(() =>
      import("@apps/patient-core/src/app/unsupported/unsupported/unsupported.component").then((m) => m.UnsupportedComponent)
    ),
  },
];

const errorRoutes: Routes = [
  {
    path: "error",
    loadComponent: loadComponentWithErrorHandling(() =>
      import("@apps/concierge-app/src/app/default-no-route/default-no-route.component").then((m) => m.ConciergeDefaultNoRouteComponent)
    ),
  },
];

const loginRoutes: Routes = [
  {
    path: "login/thank-you",
    loadComponent: loadComponentWithErrorHandling(() =>
      import("./components/login/login-thank-you/login-thank-you.component").then((m) => m.LoginThankYouComponent)
    ),
    data: {
      appView: true,
    },
  },
  {
    path: "login/action/:type",
    loadComponent: loadComponentWithErrorHandling(() =>
      import("./components/login/login-shortcut/login-shortcut.component").then((m) => m.LoginShortcutComponent)
    ),
    data: {
      appView: true,
    },
  },
  {
    path: "login",
    loadChildren: () => import("./components/login/login.routing").then((m) => m.LOGIN_ROUTES),
  },
];

export const APP_ROUTES: Routes = [
  ...loginRoutes,
  ...pairRoutes,
  ...errorRoutes,
  ...unsupportedRoute,
  ...myDentalRoutes,
  ...kioskRoutes,
  {
    path: "**",
    redirectTo: "/pair",
  },
];
